import React from 'react';

const WorkingStage = ({ waysInfo }) => {
    return (
        <div className="col-md-6">
            <div className="working-stage-card">
                <h5>{waysInfo?.index}</h5>
                <p>{waysInfo?.text}</p>
            </div>
        </div>
    );
};

export default WorkingStage;